import * as yup from 'yup';

export const getConsultationAnswerSchema = yup.object().shape({
  answer: yup.string().min(1, 'Veuillez écrire une réponse').required(''),
});
